import React, {useState} from 'react';
import '../index.css'
import NavbarNav from '../componentes/NavbarNav'
import Sidebar from '../componentes/Sidebar'
import favicon from './../imagenes/logoutm.png'
import {Contenedor} from '../elementos/Contenedor'
import { Outlet } from 'react-router-dom'
import styled from "styled-components"

const Container = styled.div`
    display: grid;
    grid-template-columns: 6.42rem auto;
    background: #fff;
    transition: all 0.3s;
    &.active{
        grid-template-columns: 16rem auto;
    }
`;

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    return (
        <>
            <Container className={sidebarOpen ? "sidebarState active" : "sidebarState"}>
                <Sidebar 
                        sidebarOpen={sidebarOpen} 
                        setSidebarOpen={setSidebarOpen}
                />
                <div className="content w-100">
                    <Contenedor>
                        <Outlet />
                    </Contenedor>
                </div>
            </Container>
        </>
    );
}
 
export default Layout;

